import { Table, TableBody, TableHead, TableRow, Typography, Box } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomButton,
} from '../../../common/components';
import { formatCurrency } from '../utils/lifeInsuranceUtils';

const LifeInsuranceImportDialog = ({ open, onClose, tableData, loading, onUpload }) => {
  return (
    <DialogContainer open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle onClose={onClose}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5">Se actualizarán los siguientes seguros de vida:</Typography>
          <CustomButton
            variant="base"
            onClick={onUpload}
            startIcon={<Refresh />}
            isLoading={loading}
            sx={{ mr: 4, padding: '10px 30px' }}
          >
            {loading ? 'Actualizando...' : 'Actualizar'}
          </CustomButton>
        </Box>
      </DialogTitle>

      <DialogBody>
        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Orden</HeadTableCell>
                <HeadTableCell>Plan</HeadTableCell>
                <HeadTableCell>Grupo</HeadTableCell>
                <HeadTableCell>Nuevo valor de seguro</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => {
                if (index === 0) return null;
                return (
                  <TableRow key={index}>
                    <RowTableCell>{row[0]}</RowTableCell>
                    <RowTableCell>{row[1]}</RowTableCell>
                    <RowTableCell>{row[2]}</RowTableCell>
                    <RowTableCell>{formatCurrency(row[3])}</RowTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </GeneralTableBox>
      </DialogBody>
    </DialogContainer>
  );
};

export default LifeInsuranceImportDialog;
